export const compactPlayerName = (value: string): string => {
  const parts = String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length <= 1) return parts.join("");
  const last = parts[parts.length - 1];
  const initials = parts
    .slice(0, -1)
    .map((part) => {
      const first = Array.from(part)[0] || "";
      return first.toLocaleUpperCase("vi-VN");
    })
    .filter(Boolean)
    .join(".");
  return initials ? `${initials}.${last}` : last;
};
